import Views from '../../views/entry/athleteUser/AthleteUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { credentialsIsComplete } from './LeftNavValidation';

const getCredentials = (viewName, route, orgUnitAthleteEntryInfoStateObjData) => {
  const isCurrent = viewName === Views.OME_MEET_CREDENTIALS;

  const isComplete = credentialsIsComplete(orgUnitAthleteEntryInfoStateObjData);

  const arePrerequisitesDone = true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_CREDENTIALS) : getInitialStateMeetRoute(Views.OME_MEET_CREDENTIALS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getCredentials;